export default "__VITE_ASSET__CUSFH6tc__"